import React from 'react'
import { useIntl } from 'react-intl'

const LineItemPromotionLabel = ({
  priceAdjustment,
  currency
}: {
  priceAdjustment: {
    appliedDiscount: {
      amount: number
      type: 'amount' | 'percentage' | 'bonus'
      percentage?: number
    }
    price: number
  }
  currency: string
}) => {
  const { formatNumber } = useIntl()
  const { appliedDiscount, price } = priceAdjustment

  switch (appliedDiscount?.type) {
    case 'percentage':
      return (
        <span className='w-24 text-right'>{`-${appliedDiscount.percentage} %`}</span>
      )
    case 'amount':
      return (
        <span className='w-24 text-right'>
          {`-${formatNumber(appliedDiscount.amount, {
            style: 'currency',
            currency,
            currencyDisplay: 'code'
          })}
          `}
        </span>
      )
    case 'bonus':
      return (
        <span className='w-24 text-right'>{`${formatNumber(price, {
          style: 'currency',
          currency,
          currencyDisplay: 'code'
        })}`}</span>
      )
    default:
      return <span className='w-24 text-right' />
  }
}

export default LineItemPromotionLabel
